import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth, useTenant } from "@/hooks";
import { backofficeTenantScopeRef } from "@/services/client";
import { resolveBackofficeTenantScopeForMe } from "@/utils/backofficeContext";

/**
 * Resolves the tenant slug published to apiClient for /tenants/me/* requests.
 * ADMIN: effectiveTenantSlug from host; MANAGER: null (backend uses JWT).
 */
export function useBackofficeTenantScope(): string | null {
  const { user } = useAuth();
  const { effectiveTenantSlug } = useTenant();
  const { pathname } = useLocation();

  return resolveBackofficeTenantScopeForMe(
    pathname,
    user?.role,
    effectiveTenantSlug,
  );
}

/**
 * Publishes backoffice tenant scope to the API client ref during layout render.
 */
export function useSyncBackofficeTenantScope(): void {
  const scopeSlug = useBackofficeTenantScope();
  backofficeTenantScopeRef.current = scopeSlug;

  useEffect(() => {
    return () => {
      backofficeTenantScopeRef.current = null;
    };
  }, []);
}
